export default {
  form: {
    should_save_payment_info: {
      label: 'Speichere meine Informationen für einen schnelleren Checkout',
    },
  },
};
